/**
 * @fileoverview Global Unlock Dialog
 *
 * Renders the WebAuthn unlock dialog globally so it can be triggered from anywhere.
 */

import { useState } from 'react';
import { WebAuthnUnlockDialog, useEncryptionStatus } from '@xanectech/auth';
import { useUnlockDialog } from '../contexts/UnlockDialogContext';
import { useEncryptionContext } from '@xanectech/encryption';

export const GlobalUnlockDialog = () => {
  const { isOpen, closeDialog } = useUnlockDialog();
  const { refresh } = useEncryptionStatus();
  const { setUnlocked } = useEncryptionContext();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleUnlockSuccess = async () => {
    // Set refreshing flag to prevent dialog from re-opening
    setIsRefreshing(true);
    // Mark as unlocked in EncryptionContext
    setUnlocked(true);
    // Refresh status to ensure all state is synchronized
    await refresh();
    // Now close the dialog
    closeDialog();
    setIsRefreshing(false);
  };

  return (
    <WebAuthnUnlockDialog
      isOpen={isOpen}
      onClose={closeDialog}
      onUnlockSuccess={handleUnlockSuccess}
      allowDismiss={true}
    />
  );
};
